import { useMutation, useQueryClient } from "react-query";

import { useClient } from "utils/client";
import { RiskGroupping } from "../types";
import { useContext } from "react";
import { ControlContext } from "context/Controls";
import { useTranslation } from "react-i18next";

export interface BatchCreateParam {
  group: RiskGroupping;
  projectCrn: string;
}

export const useBatchCreateTemplates = () => {
  const client = useClient();
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { displayNotification } = useContext(ControlContext);

  const { mutate } = useMutation(
    async (param: BatchCreateParam) => {
      return await client.post("/risk-grouping-templates", {
        isBatch: true,
        payload: param.group,
        projectCrn: param.projectCrn,
      });
    },
    {
      onSuccess: () => {
        queryClient.refetchQueries(["riskTemplates"]);
        queryClient.refetchQueries(["riskGroupingTemplates"]);

        displayNotification!(
          t("notification.saving.generic_success"),
          t("notification.saving.risk_chapter_to_template_success")
        );
      },
    }
  );

  return mutate;
};
